// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"Loader_loadingWrapper__Ehabh"};